export type { Language, SnippetConfig } from "./types";
export { secretSnippets } from "./secret";
export { proxySnippets } from "./proxy";
export { virtualEnvSnippets } from "./virtualEnv";
export { buildSnippets } from "./buildSnippets";

import type { Language } from "./types";

export const LANGUAGES: { value: Language; label: string }[] = [
  { value: "python", label: "Python" },
  { value: "javascript", label: "JavaScript" },
  { value: "curl", label: "cURL" },
  { value: "r", label: "R" },
];
